module.exports = __webpack_public_path__ + "img/select.9e1b8f51.svg";